import { UserIcon } from '@heroicons/react/24/outline'

export function NameStep({
  name,
  setName,
}: {
  name: string
  setName: (name: string) => void
}) {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Welcome to My Admin Pal</h2>
      <p className="mb-4">What should we call you?</p>
      <p className="text-sm text-gray-600 mb-4">
        We'll use this to personalize your experience, address you in emails,
        and display to other team members if you add them later.
      </p>
      <div className="relative">
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter your name"
          className="w-full px-4 py-2 border rounded-md pl-10"
        />
        <UserIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
      </div>
    </div>
  )
}
